import React, { useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet-rotatedmarker";
// Fix default marker icon issue
import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import FlightIcon from "../../../assets/flight.png";

const DefaultIcon = L.icon({
  iconUrl,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const PlaneIcon = L.icon({
  iconUrl: FlightIcon,
  iconSize: [40, 40],
  iconAnchor: [20, 20],
});
L.Marker.prototype.options.icon = DefaultIcon;

export default function FlightMap({
  airports,
  currentFlightPosition,
  heading,
}) {

  const first = airports.at(-1);
  const second = airports[0]
  
  const merge = [{...first},{...second}]
  const polylinePositions = airports.map((airport) => [
    airport.latitude,
    airport.longitude,
  ]);

  let currentFlightPolyline = [];
  if (currentFlightPosition && currentFlightPosition.length > 0) {
    currentFlightPolyline = currentFlightPosition.map((airport) => [
      airport.lat,
      airport.lon,
      
    ]);
  } else {
    currentFlightPolyline = [];
  }

  function FitMapBounds({ positions }) {
    const map = useMap();
    useEffect(() => {
      if (positions.length > 0) {
        map.fitBounds(positions);
      }
    }, [positions, map]);
    return null;
  }

  return (
    <MapContainer
      center={polylinePositions.at(-1)} // Delhi coordinates
      zoom={4}
      
      className="map-container"
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {/* Draw Polyline */}
      <Polyline
        positions={polylinePositions}
        color="#ddd"
        weight={3}
        dashArray="4, 6"
      />

      <Polyline
        positions={currentFlightPolyline}
        color="red"
        weight={3}
        // dashArray="4, 6"
      />

      {/* Markers */}
      {merge.map((airport, idx) => (
        <Marker key={idx} position={[airport.latitude, airport.longitude]}>
          <Popup>{airport.name}</Popup>
        </Marker>
      ))}

      {/* Current Flight Position Marker */}
      {currentFlightPosition && currentFlightPosition.length > 0 && (
        // currentFlightPosition.map((position, idx) => (
        <Marker
          position={[
            currentFlightPosition.at(-1).lat,
            currentFlightPosition.at(-1).lon,
          ]}
          icon={PlaneIcon}
          rotationAngle={heading}
          rotationOrigin="center"
        >
          {/* <Popup>Current Flight Position:</Popup> */}
        </Marker>
      )}

      <FitMapBounds positions={polylinePositions} />
    </MapContainer>
  );
}
